import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "how-to-add-documents"
    }}>{`How to Add Documents`}</h2>
    <p>{`This is the process of how you should add new pages and documents to this website.`}</p>
    <h3 {...{
      "id": "mdx-format"
    }}>{`MDX Format`}</h3>
    <p>{`We will be using the .mdx format to create our documents.
MDX is a format that lets you seamlessly use JSX in your Markdown documents.
You can import components, like interactive charts or notifs, and export metadata.
This makes writing long-form content with components a blast 🚀`}</p>
    <p><a parentName="p" {...{
        "href": "https://mdxjs.com/"
      }}>{`https://mdxjs.com/`}</a></p>
    <h3 {...{
      "id": "adding-document-pages"
    }}>{`Adding Document Pages`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Create a .mdx file in `}<inlineCode parentName="strong">{`src/pages`}</inlineCode></strong></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Add the required frontmatter at the top of the page. You will need this if you
want it to display in the sidebar.`}</strong></p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-markdown"
          }}>{`  // Your .mdx page
  ---
  title: How to Add Documents
  ---
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`You have the option to create React Components and add them to the MDX file.
React components for pages should be located in src/components`}</strong></p>
      </li>
    </ul>
    <h3 {...{
      "id": "updating-the-sidebar"
    }}>{`Updating the sidebar`}</h3>
    <p>{`After you've added a page, you may want to add it to the sidebar. At `}<inlineCode parentName="p">{`src/sidebar.js`}</inlineCode>{`, you'll find the layout for
the main site navigation and sidebar. You can add your page where it makes sense in the site's information architecture.`}</p>
    <p>{`There are examples in the sidebar file to follow. You'll need to add an object with `}<inlineCode parentName="p">{`name`}</inlineCode>{` and `}<inlineCode parentName="p">{`href`}</inlineCode>{` properties
for regular links and you can also create nested sections by leaving out `}<inlineCode parentName="p">{`href`}</inlineCode>{` and adding an `}<inlineCode parentName="p">{`items`}</inlineCode>{` array to objects.`}</p>
    <h3 {...{
      "id": "graphql-sample-reference"
    }}>{`GraphQl Sample Reference`}</h3>
    <p>{`  `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/graphql-reference/"
      }}>{`https://www.gatsbyjs.org/docs/graphql-reference/`}</a></p>
    <h3 {...{
      "id": "github-api-graphql-explorer"
    }}>{`Github API GraphQL Explorer`}</h3>
    <p>{`  `}<a parentName="p" {...{
        "href": "https://developer.github.com/v4/explorer/"
      }}>{`https://developer.github.com/v4/explorer/`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      